import { render, staticRenderFns } from "./FormatoCurriculumVitae.vue?vue&type=template&id=a61dd7de&scoped=true"
import script from "./FormatoCurriculumVitae.vue?vue&type=script&lang=js"
export * from "./FormatoCurriculumVitae.vue?vue&type=script&lang=js"
import style0 from "./FormatoCurriculumVitae.vue?vue&type=style&index=0&id=a61dd7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61dd7de",
  null
  
)

export default component.exports